import { Box, BoxProps, Grid } from '@core/component';
import { useContextMediaQuery } from '@core/context';

import { TableOfContent } from './TableOfContent';
import { TABLE_OF_CONTENT_ID } from './constants';

export const TableOfContentContainer = ({
  children,
  isEnabled,
  ...restProps
}: BoxProps & {
  isEnabled: boolean;
}) => {
  const { isPhone } = useContextMediaQuery();

  return isEnabled ? (
    <Box id={TABLE_OF_CONTENT_ID} {...restProps} overflow={isPhone ? 'hidden' : undefined}>
      <Grid isContainer spacing={60}>
        <Grid lg={4}>
          <TableOfContent>{children}</TableOfContent>
        </Grid>
        <Grid lg={8}>{children}</Grid>
      </Grid>
    </Box>
  ) : (
    <Box {...restProps}>{children}</Box>
  );
};
